import React from 'react'
import { Container, Title } from './styles'
import { AnalyticalModelTabs } from '~/components/analyticalModels'
import { withDashboardLoader } from '~/components/shared'
import { message } from '~/services'
import { useDocumentTitle } from '~/hooks'

const AnalyticalModelsPage = (): JSX.Element => {
  useDocumentTitle(message('titles.analytical_models'))

  return (
    <Container>
      <Title>{message('analyticalModels.analytical_models')}</Title>
      <AnalyticalModelTabs />
    </Container>
  )
}

export const AnalyticalModels = withDashboardLoader(AnalyticalModelsPage)
